import React from 'react';
import { observer } from 'mobx-react';
import { ModelBase } from 'core/model/model.types';
import Checkbox from 'core/components/Checkbox';

export type SelectableModel = ModelBase & {
  select(options: { multi: boolean; shiftKey: boolean }): void;
  isSelectable: boolean;
  isSelected: boolean;
};

interface Props {
  model: SelectableModel;
  checked?: boolean | null;
  disabled?: boolean | null;
}

function CheckboxCell({ model, checked = null, disabled = null }: Props) {
  return (
    // Using div wrapper, since Firefox won't forward <label> shift/ctrl+click events (Bugzilla 559506).
    <div
      style={{ display: 'inline-flex' }}
      onKeyDown={(e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          e.stopPropagation();
          if (disabled ?? !model.isSelectable) {
            return;
          }
          model.select({ multi: true, shiftKey: e.shiftKey });
        }
      }}
      onClick={(e) => {
        e.stopPropagation();
        // Ignore the browser-synthesized INPUT click (double-toggle guard).
        if ((e.target as HTMLElement).nodeName === 'INPUT') {
          return;
        }
        if (disabled ?? !model.isSelectable) {
          return;
        }
        model.select({ multi: true, shiftKey: e.shiftKey });
      }}
    >
      <Checkbox
        aria-label="Select row"
        checked={checked ?? model.isSelected}
        disabled={disabled ?? !model.isSelectable}
        mb={0}
      />
    </div>
  );
}

export default observer(CheckboxCell);
